import type { CharacterId, GiantId } from '../../../domain/ids/ids';
import type { RockPipeShape } from '../../../domain';
import claudiImg from '../components/atomic/character/characters_image/claudi.png';
import eddyImg from '../components/atomic/character/characters_image/eddy.png';
import rockImg from '../components/atomic/character/characters_image/rock.png';
import tuchiImg from '../components/atomic/character/characters_image/tuchi.png';
import ufoImg from '../components/atomic/character/characters_image/ufo.png';
import vallImg from '../components/atomic/character/characters_image/vall.png';
import { getStaticObstacleUrl } from '../level_screen/gameplay/levelVisualAssets';
import claudiClosedCard from './claudi/closed_card.png';
import claudiOpenCard from './claudi/open_card.png';
import claudiTile from './claudi/mini_game_tile.png';
import claudiTimer from './claudi/timer.png';
import claudiTitle from './claudi/title.png';
import claudiVictory from './claudi/victory.png';
import eddyButton from './eddy/button_take_photo.png';
import eddyFrame from './eddy/frame_photo.png';
import eddyMem01 from './eddy/mem01.png';
import eddyMem02 from './eddy/mem02.png';
import eddyMem03 from './eddy/mem03.png';
import eddyMem04 from './eddy/mem04.png';
import eddyMem05 from './eddy/mem05.png';
import eddyMem06 from './eddy/mem06.png';
import eddyTile from './eddy/mini_game_tile.png';
import eddyTimer from './eddy/timer.png';
import eddyVictory from './eddy/victory_eddi.png';
import rockDetail1 from './rock/detail1.png';
import rockDetail2 from './rock/detail2.png';
import rockDetail3 from './rock/detail3.png';
import rockFinish from './rock/finish.png';
import rockHeader from './rock/header.png';
import rockHint from './rock/hint.png';
import rockTile from './rock/mini_game_tile.png';
import rockTimer from './rock/timer.png';
import rockVictory from './rock/victory.png';
import tuchiButtonListen from './tuchi/button_listen.png';
import tuchiFrame from './tuchi/frame1.png';
import tuchiFrameNote1 from './tuchi/frame_note1.png';
import tuchiFrameNote2 from './tuchi/frame_note2.png';
import tuchiFrameNote3 from './tuchi/frame_note3.png';
import tuchiFrameNote4 from './tuchi/frame_note4.png';
import tuchiTile from './tuchi/mini-game_tile.png';
import tuchiNote1 from './tuchi/note1.png';
import tuchiNote2 from './tuchi/note2.png';
import tuchiNote3 from './tuchi/note3.png';
import tuchiNote4 from './tuchi/note4.png';
import tuchiTimer from './tuchi/timer.png';
import tuchiVictory from './tuchi/victory_tychi.png';
import vallButton from './vall/button_drop.png';
import vallHeader from './vall/mini-game_tile_header.png';
import vallMiddle from './vall/mini-game_tile_vall_middle.png';
import vallTile from './vall/mini_game_tile.png';
import vallPackage1 from './vall/package_color1.png';
import vallPackage2 from './vall/package_color2.png';
import vallPackage3 from './vall/package_color3.png';
import vallPackage4 from './vall/package_color4.png';
import vallTimer from './vall/timer.png';
import vallVictory from './vall/victory_vall.png';
import ufoTile from './ufo/mini-game_tile.png';
import ufoBubble from './ufo/bubble.png';
import ufoCharacter from './ufo/Group.png';
import ufoTimer from './ufo/timer.png';
import ufoVictory from './ufo/victory.png';
import ufoQuizNeutral from './ufo/quiz_button_neutral.png';
import ufoQuizGood from './ufo/quiz_button_good.png';
import ufoQuizBad from './ufo/quiz_button_bad.png';

export const COURIER_MINIGAME_PORTRAITS: Record<CharacterId, string> = {
  eddy: eddyImg,
  claudi: claudiImg,
  tuchi: tuchiImg,
  ufo: ufoImg,
  vall: vallImg,
  rock: rockImg,
};

export function getCourierMinigamePortrait(courierId: CharacterId): string {
  return COURIER_MINIGAME_PORTRAITS[courierId];
}

export function getClaudiPairImageUrl(giantId: GiantId): string {
  return getStaticObstacleUrl(giantId);
}

/** Layout assets from `.dev/claudi` (min-game.svg / victory.png). */
export const CLAUDI_CLOSED_CARD_URL = claudiClosedCard;
export const CLAUDI_OPEN_CARD_URL = claudiOpenCard;
export const CLAUDI_TILE_URL = claudiTile;
export const CLAUDI_TIMER_URL = claudiTimer;
export const CLAUDI_TITLE_URL = claudiTitle;
export const CLAUDI_VICTORY_URL = claudiVictory;

/** Layout assets from `.dev/eddy` (mini-game1.svg). */
export const EDDY_TILE_URL = eddyTile;
export const EDDY_FRAME_URL = eddyFrame;
export const EDDY_BUTTON_URL = eddyButton;
export const EDDY_TIMER_URL = eddyTimer;
export const EDDY_VICTORY_URL = eddyVictory;

/** Мемы для «Сними удачный кадр» (из `.dev/мемы`). */
export const EDDY_MEME_URLS: readonly string[] = [
  eddyMem01,
  eddyMem02,
  eddyMem03,
  eddyMem04,
  eddyMem05,
  eddyMem06,
];

export function pickEddyMemeUrl(random: () => number = Math.random): string {
  const index = Math.floor(random() * EDDY_MEME_URLS.length);
  return EDDY_MEME_URLS[index] ?? EDDY_MEME_URLS[0]!;
}

/** Layout assets from `.dev/rock` (mini-game.svg / variants.png). */
export const ROCK_TILE_URL = rockTile;
export const ROCK_HEADER_URL = rockHeader;
export const ROCK_TIMER_URL = rockTimer;
export const ROCK_HINT_URL = rockHint;
export const ROCK_FINISH_URL = rockFinish;
export const ROCK_VICTORY_URL = rockVictory;
export const ROCK_DETAIL_STRAIGHT_URL = rockDetail1;
export const ROCK_DETAIL_CORNER_URL = rockDetail2;
export const ROCK_DETAIL_TEE_URL = rockDetail3;

/** Layout assets from `.dev/tuchi` (mini-game3.svg). */
export const TUCHI_TILE_URL = tuchiTile;
export const TUCHI_TIMER_URL = tuchiTimer;
export const TUCHI_BUTTON_LISTEN_URL = tuchiButtonListen;
export const TUCHI_FRAME_URL = tuchiFrame;
export const TUCHI_NOTE1_URL = tuchiNote1;
export const TUCHI_NOTE2_URL = tuchiNote2;
export const TUCHI_NOTE3_URL = tuchiNote3;
export const TUCHI_NOTE4_URL = tuchiNote4;
/** Square note icons for filled melody slots (from `.dev/tuchi notes`). */
export const TUCHI_FRAME_NOTE1_URL = tuchiFrameNote1;
export const TUCHI_FRAME_NOTE2_URL = tuchiFrameNote2;
export const TUCHI_FRAME_NOTE3_URL = tuchiFrameNote3;
export const TUCHI_FRAME_NOTE4_URL = tuchiFrameNote4;
export const TUCHI_VICTORY_URL = tuchiVictory;

export const TUCHI_NOTE_URLS: Record<1 | 2 | 3 | 4, string> = {
  1: TUCHI_NOTE1_URL,
  2: TUCHI_NOTE2_URL,
  3: TUCHI_NOTE3_URL,
  4: TUCHI_NOTE4_URL,
};

export const TUCHI_FRAME_NOTE_URLS: Record<1 | 2 | 3 | 4, string> = {
  1: TUCHI_FRAME_NOTE1_URL,
  2: TUCHI_FRAME_NOTE2_URL,
  3: TUCHI_FRAME_NOTE3_URL,
  4: TUCHI_FRAME_NOTE4_URL,
};

/** Layout assets from `.dev/vall` (mini-game5.svg). */
export const VALL_TILE_URL = vallTile;
export const VALL_HEADER_URL = vallHeader;
export const VALL_MIDDLE_URL = vallMiddle;
export const VALL_BUTTON_URL = vallButton;
export const VALL_TIMER_URL = vallTimer;
export const VALL_VICTORY_URL = vallVictory;
export const VALL_PACKAGE1_URL = vallPackage1;
export const VALL_PACKAGE2_URL = vallPackage2;
export const VALL_PACKAGE3_URL = vallPackage3;
export const VALL_PACKAGE4_URL = vallPackage4;

export const VALL_PACKAGE_URLS: readonly string[] = [
  VALL_PACKAGE1_URL,
  VALL_PACKAGE2_URL,
  VALL_PACKAGE3_URL,
  VALL_PACKAGE4_URL,
];

export function getRockPipeShapeUrl(shape: Exclude<RockPipeShape, 'empty'>): string {
  switch (shape) {
    case 'straight':
      return ROCK_DETAIL_STRAIGHT_URL;
    case 'corner':
      return ROCK_DETAIL_CORNER_URL;
    case 'tee':
      return ROCK_DETAIL_TEE_URL;
    default: {
      const _exhaustive: never = shape;
      return _exhaustive;
    }
  }
}

/** Layout assets from `.dev/ufo` (mini-game4.svg). */
export const UFO_TILE_URL = ufoTile;
export const UFO_BUBBLE_URL = ufoBubble;
export const UFO_CHARACTER_URL = ufoCharacter;
export const UFO_TIMER_URL = ufoTimer;
export const UFO_VICTORY_URL = ufoVictory;
export const UFO_QUIZ_NEUTRAL_URL = ufoQuizNeutral;
export const UFO_QUIZ_GOOD_URL = ufoQuizGood;
export const UFO_QUIZ_BAD_URL = ufoQuizBad;
